import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTenders } from 'common/utilities/content';
import { deleteSavedCard } from '@kfc-global/react-shared/redux/Actions/PaymentsAction';
import MyPaymentMethodsView from '../Presentation/MyPaymentMethodsView';
import { cardDeleteSuccessCallback } from '../utils/myPaymentMethodsUtils';

const MyPaymentMethodsContainer = (props) => { 
    const dispatch = useDispatch();
    useEffect(() => {
        window.scrollTo(0, 0);
        dispatch(getTenders());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);   
    
    const {profileReducer, paymentsContentReducer, tenantReducer} = useSelector(state => state);
    const { customerId, savedCards } = profileReducer;
    const payment = paymentsContentReducer;
    const { tenantId } = tenantReducer;
    const { accountPage: { addNewCreditOrDebitCard, maxSavedCardLimit} = {} } =
    tenantReducer?.componentOptions?.web ?? {};

  const allCardsTypesList = payment?.tendersContent?.items;

  const handleDeleteCard = cardId => {
    dispatch(deleteSavedCard({ customerId, tenantId, cardId }, 
      params => {
          cardDeleteSuccessCallback(dispatch)
        },
    ))
  };

  const params = { savedCards, allCardsTypesList, handleDeleteCard ,addNewCreditOrDebitCard, maxSavedCardLimit};

  return <MyPaymentMethodsView {...props} {...params} />;
};

export default MyPaymentMethodsContainer;
